import UserLogin from '@/components/UserLogin.vue';
import AccordionListing from '@/components/accordion/AccordionListing.vue';
import AccordionEdit from '@/components/accordion/AccordionEdit.vue';
import ClientListing from '@/components/client/ClientListing.vue';
import ClientEdit from '@/components/client/ClientEdit.vue';
import SurveyListing from '@/components/survey/SurveyListing.vue';
import SurveyEdit from '@/components/survey/SurveyEdit.vue';
import QuestionListing from '@/components/question/QuestionListing.vue';
import QuestionEdit from '@/components/question/QuestionEdit.vue';
import AttributeListing from '@/components/attribute/AttributeListing.vue'; 
import MediaProperties from '@/components/mediaproperty/MediaProperties.vue';
import MediaPropertyEdit from '@/components/mediaproperty/MediaPropertyEdit.vue';
import LogActivityListing from '@/components/logActivityType/Listing.vue';
import FeedbackSubjectListing from '@/components/FeedbackSubject/Listing.vue';
import SharedDetailListing from '@/components/sharedAccordionDetail/Listing.vue';
import TagListing from '@/components/tag/Listing.vue';
import TestConfiguration from '@/components/test/TestConfiguration.vue';
import AccordionTest from '@/components/accordion/AccordionTest.vue';
import BenComTools from '@/components/benComms/BenComTools.vue';
import AITranscriptionListing from '@/components/aitranscription/Listing.vue';
import AITranscriptionEdit from '@/components/aitranscription/AITranscriptionEdit.vue';

import { LoginCallback, navigationGuard } from '@okta/okta-vue';
import { createRouter, createWebHistory } from 'vue-router';
import { nextTick } from 'vue';
import config from '../../config';

const CALLBACK_PATH = '/login/callback';

let authEnforced = true; 
if(config.baseUrl === "http://localhost:8080") {
    authEnforced = false;
}

const routes = [
    {
        path: CALLBACK_PATH,
        component: LoginCallback
    },
    {
        path: '/login',
        component: UserLogin
    },
    {
        path: '/accordions',
        component: AccordionListing,
        meta: {
            title: 'Accordion Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/accordionEdit',
        component: AccordionEdit,
        meta: { requiresAuth: authEnforced }
    },
    {
        path: '/clients',
        component: ClientListing,
        meta: { 
            title: 'Client Maintenance',
            requiresAuth: authEnforced ,
            inMenu: true
        }
    },
    {
        path: '/clientEdit',
        component: ClientEdit,
        meta: { requiresAuth: authEnforced }
    },
    {
        path: '/surveys',
        component: SurveyListing,
        meta: {
            title: 'Survey Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/surveyEdit',
        component: SurveyEdit,
        meta: { requiresAuth: authEnforced }
    },
    {
        path: '/questions',
        component: QuestionListing,
        meta: {
            title: 'Question Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/questionEdit',
        component: QuestionEdit,
        meta: {
            title: 'Question Maintenance',
            requiresAuth: authEnforced
        }
    },
    {
        path: '/attributes',
        component: AttributeListing,
        meta: {
            title: 'Attribute Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/MediaProperties',
        component: MediaProperties,
        meta: {
            title: 'Media Property Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/mediaPropertyEdit',
        name: 'MediaPropertyEdit',
        component: MediaPropertyEdit,
        meta: { requiresAuth: authEnforced }
    },
    {
        path: '/LogActivityTypes',
        component: LogActivityListing,
        meta: {
            title: 'Log Activity Type Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/FeedbackSubjects',
        component: FeedbackSubjectListing,
        meta: {
            title: 'Feedback Subject Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/tag',
        component: TagListing,
        meta: {
            title: "Tag Maintenance",
            requiresAuth: authEnforced ,
            inMenu: true
        }
    },
    {
        path: '/sharedAccordionDetail',
        component: SharedDetailListing,
        meta: {
            title: "Shared Accordion Detail Maintenance",
            requiresAuth: authEnforced ,
            inMenu: true
        }
    },
    {
        path: '/TestConfiguration',
        component: TestConfiguration,
        meta: {
            title: 'Test Configuration Maintenance',
            requiresAuth: authEnforced
        }
    },
    {
        path: '/AccordionTest',
        component: AccordionTest,
        meta: {
            title: 'Test Accordion',
            requiresAuth: authEnforced
        }
    },
    {
        path: '/BenComms',
        component: BenComTools,
        meta: {
            title: 'BenComms Helpers',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/AITranscriptions',
        component: AITranscriptionListing,
        meta: {
            title: 'AI Transcription Maintenance',
            requiresAuth: authEnforced,
            inMenu: true
        }
    },
    {
        path: '/AITranscriptionEdit',
        component: AITranscriptionEdit,
        meta: {
            title: 'AI Transcription Edit',
            requiresAuth: authEnforced
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
});

const DEFAULT_TITLE = 'JV S&S Maintenance';

router.beforeEach(navigationGuard);

router.afterEach((to) => {
    nextTick(() => {
        if(to.path.toLowerCase() === '/accordionedit') {
            const urlParams = new URLSearchParams(to.query);
            document.title = 'Accordion - ' + urlParams.get('Code');
        } else if(to.path.toLowerCase() === '/clientedit') {
            const urlParams = new URLSearchParams(to.query);
            document.title = 'Client - ' + urlParams.get('Code');
        } else if(to.path.toLowerCase() === '/surveyedit') {
            const urlParams = new URLSearchParams(to.query);
            document.title = 'Survey - ' + urlParams.get('Code');
        } else {
            document.title = to.meta.title || DEFAULT_TITLE;
        }
    })
});

export default router;